import * as React from "react";

import "./orders-header.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

export const OrdersHeader = ({search}: {search?: any}) => cs(
    consumeContext("routerHistory"),
    ({routerHistory}) => (
        <div className="orders-header-c3po">
            <div className="right">
                <div className="links">
                    <a
                        className="start-new-order"
                        xd-qa-type="link"
                        xd-qa-name="Start a New Order"
                        onClick={() => routerHistory.push("/")}
                        hidden={false}
                    >
                        Start a New Order
                    </a>
                </div>
                {search}
            </div>
        </div>
    )
);

